export function convertDeepLinkToObject(deepLinkString: string): { [key: string]: any } {
    const vars: { [key: string]: any } = {};
    const hashes = deepLinkString.startsWith('?') ? deepLinkString.substr(1).split('&') : deepLinkString.split('&');

    for (let i = 0; i < hashes.length; i++) {
        const [rawKey, rawValue] = hashes[i].split('=');
        const key = decodeURIComponent(rawKey);
        const value = decodeURIComponent(rawValue || '');

        // Handle bracketed keys
        const match = key.match(/^([^\[]+)\[([^\]]+)\]$/);
        if (match) {
            const parentKey = match[1];
            const childKey = match[2];
            if (!vars[parentKey]) vars[parentKey] = {};
            vars[parentKey][childKey] = value;
        } else {
            vars[key] = value;
        }
    }

    return vars;
}
